/**
 * Platform icon display style.
 *
 * Historically this was a user-toggleable /settings preference (original
 * platform logo icons vs. GGC V2. design-guide badge squares), persisted to
 * localStorage. The badge style was standardized as the only look and the
 * toggle was removed from /settings — this now just exposes the fixed value
 * via the same hook shape so all existing call sites keep working unchanged.
 */

export type PlatformIconStyle = 'badge' | 'icon';

export const DEFAULT_PLATFORM_ICON_STYLE: PlatformIconStyle = 'badge';

/** Always returns the fixed style — kept as a hook for call-site compatibility. */
export function usePlatformIconStyle(): PlatformIconStyle {
  return DEFAULT_PLATFORM_ICON_STYLE;
}
